import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

import './WriteOffReasonSection.scss'



const WriteOffReasonSection = (props) => {
    return <div className="write-off-reason-section-card" >
        <div className="section-header">
            <span className="section-header-title" >{props.sectionName}</span>
            <span className="scope-divider"></span>
            <span className="section-header-scope" >   {props.sectionScope} </span>
        </div>

        <div className="section-footer">
            <span className="section-footer-value">{props.fields.WriteOffReason}</span>
        </div>
    </div>

}

WriteOffReasonSection.propTypes = {
    reason: PropTypes.object,
    sectionName: PropTypes.string,
    sectionScope: PropTypes.string

};

WriteOffReasonSection.defaultProps = {};

export default (WriteOffReasonSection);